// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicMaintenanceRouteImport } from './routes/_public/maintenance'
import { Route as PublicPasswordResetRouteImport } from './routes/_public/password-reset'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as AuthenticatedAdminApiKeysRouteImport } from './routes/_authenticated/admin/api-keys'
import { Route as AuthenticatedAdminApiLogsRouteImport } from './routes/_authenticated/admin/api-logs'
import { Route as AuthenticatedAdminAuditLogsRouteImport } from './routes/_authenticated/admin/audit-logs'
import { Route as AuthenticatedAdminStatisticsRouteImport } from './routes/_authenticated/admin/statistics'
import { Route as AuthenticatedAdminSystemSettingsRouteImport } from './routes/_authenticated/admin/system-settings'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedAdminWebsitesRouteImport } from './routes/_authenticated/admin/websites'
import { Route as AuthenticatedAdminUpdatesCompletedRouteImport } from './routes/_authenticated/admin/updates/completed'
import { Route as AuthenticatedAdminUpdatesFailedRouteImport } from './routes/_authenticated/admin/updates/failed'
import { Route as AuthenticatedAdminUpdatesPendingRouteImport } from './routes/_authenticated/admin/updates/pending'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const PublicRouteRoute = PublicRouteRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const SetupRoute = SetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => PublicRouteRoute
          })
const PublicLoginRoute = PublicLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => PublicRouteRoute
          })
const PublicMaintenanceRoute = PublicMaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => PublicRouteRoute
          })
const PublicPasswordResetRoute = PublicPasswordResetRouteImport.update({
            id: '/password-reset',path: '/password-reset',getParentRoute: () => PublicRouteRoute
          })
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PublicRouteRoute
          })
const PublicTermsRoute = PublicTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => PublicRouteRoute
          })
const AuthenticatedAdminApiKeysRoute = AuthenticatedAdminApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminApiLogsRoute = AuthenticatedAdminApiLogsRouteImport.update({
            id: '/api-logs',path: '/api-logs',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAuditLogsRoute = AuthenticatedAdminAuditLogsRouteImport.update({
            id: '/audit-logs',path: '/audit-logs',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminStatisticsRoute = AuthenticatedAdminStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSystemSettingsRoute = AuthenticatedAdminSystemSettingsRouteImport.update({
            id: '/system-settings',path: '/system-settings',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminWebsitesRoute = AuthenticatedAdminWebsitesRouteImport.update({
            id: '/websites',path: '/websites',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminUpdatesCompletedRoute = AuthenticatedAdminUpdatesCompletedRouteImport.update({
            id: '/updates/completed',path: '/updates/completed',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminUpdatesFailedRoute = AuthenticatedAdminUpdatesFailedRouteImport.update({
            id: '/updates/failed',path: '/updates/failed',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminUpdatesPendingRoute = AuthenticatedAdminUpdatesPendingRouteImport.update({
            id: '/updates/pending',path: '/updates/pending',getParentRoute: () => AuthenticatedAdminRouteRoute
          })





const AuthenticatedAdminRouteRouteChildren = {
  AuthenticatedAdminApiKeysRoute: AuthenticatedAdminApiKeysRoute,AuthenticatedAdminApiLogsRoute: AuthenticatedAdminApiLogsRoute,AuthenticatedAdminAuditLogsRoute: AuthenticatedAdminAuditLogsRoute,AuthenticatedAdminStatisticsRoute: AuthenticatedAdminStatisticsRoute,AuthenticatedAdminSystemSettingsRoute: AuthenticatedAdminSystemSettingsRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminWebsitesRoute: AuthenticatedAdminWebsitesRoute,AuthenticatedAdminUpdatesCompletedRoute: AuthenticatedAdminUpdatesCompletedRoute,AuthenticatedAdminUpdatesFailedRoute: AuthenticatedAdminUpdatesFailedRoute,AuthenticatedAdminUpdatesPendingRoute: AuthenticatedAdminUpdatesPendingRoute
}

const AuthenticatedAdminRouteRouteWithChildren = AuthenticatedAdminRouteRoute._addFileChildren(AuthenticatedAdminRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const PublicRouteRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,PublicLoginRoute: PublicLoginRoute,PublicMaintenanceRoute: PublicMaintenanceRoute,PublicPasswordResetRoute: PublicPasswordResetRoute,PublicPrivacyRoute: PublicPrivacyRoute,PublicTermsRoute: PublicTermsRoute
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(PublicRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,PublicRouteRoute: PublicRouteRouteWithChildren,SplatRoute: SplatRoute,SetupRoute: SetupRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)